module.exports = __webpack_public_path__ + "static/media/appleStore-ptBR.2049e321.png";